<template>
  <div class="report-suspect-page">
    <div class="row pb-2 d-flex align-items-center justify-content-between">
      <div class="col-auto">
        <h3 class="mb-1 report-suspect-title">Report Suspect</h3>
      </div>

      <div class="col-auto">
        <div class="d-flex align-items-center mb-1 latest-update-container">
          <span class="latest-update-text">Latest Update: {{ latestUpdateDate }}</span>
          <b-button id="latest-update-tooltip" variant="link" class="p-0 ml-1" v-b-tooltip.hover>
            <img src="@/assets/img/tooltip-icon.svg" alt="Info tooltip" class="tooltip-icon" />
          </b-button>
          <b-tooltip target="latest-update-tooltip" triggers="hover" custom-class="left-aligned-tooltip" html>
            <h5 class="mb-1">Latest Update</h5>
            Data diperbarui harian (D-1)
          </b-tooltip>
        </div>
      </div>

      <!-- <div class="col-auto">
        <div style="position: relative">
          <i class="fas fa-calendar prefix-icon"></i>
          <div class="prefix-input">
            <flat-pickr
              :config="rangePickr"
              placeholder="Select Periode"
              v-model="selected.date"
              class="flatpickr-inter"
            ></flat-pickr>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Stats Start -->
    <div id="view-stats" class="row mb-5">
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats
            title="Total Report Suspect"
            :tooltipText="'Total Report Suspect'"
            :tooltipBody="'Jumlah laporan kode QR yang dianggap mencurigakan'"
            :value="reportSuspectData.stats.total_report"
            unit="Activities"
            :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFEECE' />
                <path
                    d='M28.4448 35.2515C28.7953 35.2515 29.0892 35.1327 29.3266 34.8953C29.5641 34.6578 29.6824 34.3643 29.6816 34.0147C29.6807 33.6652 29.562 33.3717 29.3254 33.1342C29.0888 32.8968 28.7953 32.778 28.4448 32.778C28.0944 32.778 27.8009 32.8968 27.5643 33.1342C27.3277 33.3717 27.209 33.6652 27.2081 34.0147C27.2073 34.3643 27.326 34.6582 27.5643 34.8965C27.8026 35.1348 28.0961 35.2531 28.4448 35.2515ZM27.2081 30.3046H29.6816V22.8843H27.2081V30.3046ZM23.8072 40.1983L17.3145 33.7056V24.4302L23.8072 17.9375H33.0825L39.5752 24.4302V33.7056L33.0825 40.1983H23.8072Z'
                    fill='#E8A527'
                />
                </svg>
            `"
          ></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats
            title="Scan More Than 5"
            :tooltipText="'Scan More Than 5'"
            :tooltipBody="'Jumlah kode QR yang melakukan scan lebih dari 5 kali'"
            :value="reportSuspectData.stats.scan_more_than_5"
            unit="Activities"
            :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#F1EDFD'/>
                <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M19.6035 30.1266V28.3266H37.6035V30.1266H19.6035ZM32.2035 38.2266V36.4266H35.8035V32.8266H37.6035V36.4266C37.6035 37.4207 36.8709 38.2266 35.9672 38.2266H32.2035ZM25.0035 38.2266H21.2399C20.3361 38.2266 19.6035 37.4207 19.6035 36.4266V32.8266H21.4035V36.4266H25.0035V38.2266ZM32.2035 20.2266H35.9672C36.8709 20.2266 37.6035 21.0324 37.6035 22.0266V25.6266H35.8035V22.0266H32.2035V20.2266ZM25.0035 20.2266V22.0266H21.4035V25.6266H19.6035V22.0266C19.6035 21.0324 20.3361 20.2266 21.2399 20.2266H25.0035Z'
                    fill='#A94AE4'
                    stroke='#A94AE4'
                />
                </svg>
            `"
            circle_bg_color="#ecf5fb"
            circle_text_color="#267de4"
          ></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats
            title="Scan Different Location"
            :tooltipText="'Scan Different Location'"
            :tooltipBody="'Jumlah kode QR yang melakukan scan di tempat berbeda dalam waktu yang berdekatan'"
            :value="reportSuspectData.stats.scan_different_location"
            unit="Activities"
            :icon="`
                <svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#ECF5FB'/>
                <path d='M39.5752 35.0395V28.0311C39.5752 26.7399 39.5752 26.0944 39.2253 25.6083C38.9421 25.2163 38.4882 25.0073 37.6794 24.7266C37.5136 26.7127 36.8557 28.7422 35.8231 30.5168C34.6197 32.5846 32.8327 34.4335 30.5435 35.4315C29.8813 35.7192 29.1669 35.8676 28.4448 35.8676C27.7228 35.8676 27.0084 35.7192 26.3462 35.4315C24.057 34.4335 22.27 32.5846 21.0666 30.5168C20.282 29.1681 19.7246 27.6995 19.4169 26.1698C18.9432 26.0993 18.5808 26.1352 18.2667 26.3096C18.142 26.3796 18.0258 26.4638 17.9204 26.5606C17.3145 27.1122 17.3145 28.1374 17.3145 30.1891V36.2861C17.3145 37.576 17.3145 38.2215 17.6644 38.7076C18.0144 39.1936 18.6266 39.3977 19.8509 39.8058L20.3258 39.9641C22.2761 40.6133 23.2507 40.9386 24.2487 40.9411C24.5488 40.9411 24.8481 40.9196 25.1465 40.8768C26.1334 40.7345 27.061 40.2708 28.916 39.3432C30.337 38.6321 31.0481 38.2772 31.8025 38.1127C32.0672 38.055 32.3351 38.0146 32.6064 37.9915C33.3769 37.9272 34.1523 38.0571 35.7068 38.3155C37.2811 38.5777 38.0689 38.7088 38.644 38.3786C38.8411 38.2657 39.0113 38.1214 39.1548 37.9458C39.5752 37.4325 39.5752 36.6349 39.5752 35.0395Z' fill='#267CE5'/>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M28.4437 16.6992C24.3452 16.6992 21.0234 19.8553 21.0234 23.7485C21.0234 27.612 23.3917 32.1198 27.087 33.7312C27.5153 33.9167 27.977 34.0124 28.4437 34.0124C28.9104 34.0124 29.3721 33.9167 29.8004 33.7312C33.4957 32.121 35.864 27.612 35.864 23.7485C35.864 19.8553 32.5422 16.6992 28.4437 16.6992ZM28.4437 26.5929C29.0997 26.5929 29.7288 26.3323 30.1927 25.8685C30.6565 25.4046 30.9171 24.7755 30.9171 24.1195C30.9171 23.4635 30.6565 22.8344 30.1927 22.3705C29.7288 21.9067 29.0997 21.6461 28.4437 21.6461C27.7877 21.6461 27.1586 21.9067 26.6947 22.3705C26.2309 22.8344 25.9703 23.4635 25.9703 24.1195C25.9703 24.7755 26.2309 25.4046 26.6947 25.8685C27.1586 26.3323 27.7877 26.5929 28.4437 26.5929Z' fill='#267CE5'/>
                </svg>
            `"
            circle_bg_color="#e6f5f0"
            circle_text_color="#20c661"
          ></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats
            title="QR Not Found"
            :tooltipText="'QR Not Found'"
            :tooltipBody="'Kode QR yang tidak ditemukan dalam sistem database'"
            :value="reportSuspectData.stats.fake_qr"
            unit="Activities"
            :icon="`<svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFE8E8'/>
                <path d='M37.5721 34.1065C37.572 34.1065 37.5722 34.1066 37.5721 34.1065L31.9649 28.4992L37.5719 22.8921C37.6302 22.8337 37.6754 22.7632 37.7041 22.6859C37.7807 22.4805 37.737 22.2404 37.5719 22.0752L34.9232 19.4265C34.758 19.2614 34.5179 19.2178 34.3126 19.2944C34.2352 19.3231 34.1649 19.3681 34.1065 19.4263C34.1065 19.4264 34.1065 19.4263 34.1065 19.4263L28.4992 25.0337L22.8921 19.4265C22.8337 19.3683 22.7633 19.3231 22.6859 19.2944C22.4805 19.2178 22.2404 19.2615 22.0753 19.4265L19.4266 22.0753C19.2614 22.2404 19.2178 22.4806 19.2944 22.6859C19.3231 22.7633 19.3681 22.8335 19.4264 22.8919C19.4263 22.8919 19.4265 22.892 19.4264 22.8919L25.0337 28.4992L19.4266 34.1064C19.3683 34.1648 19.3231 34.2352 19.2944 34.3126C19.2177 34.5179 19.2614 34.7581 19.4266 34.9232L22.0753 37.5719C22.2405 37.737 22.4806 37.7807 22.6859 37.7041C22.7633 37.6754 22.8336 37.6304 22.892 37.5721C22.8919 37.5722 22.892 37.572 22.892 37.5721L28.4993 31.9648L34.1064 37.5719C34.1648 37.6302 34.2352 37.6754 34.3126 37.7041C34.518 37.7807 34.7581 37.737 34.9232 37.5719L37.5719 34.9232C37.737 34.7581 37.7807 34.5179 37.7041 34.3126C37.6754 34.2352 37.6304 34.1649 37.5721 34.1065Z' fill='#D05555'/>
                </svg>
            `"
            circle_bg_color="#ffe8e8"
            circle_text_color="#d05555"
          ></report-suspect-stats>
        </div>
      </div>
      <div class="col">
        <div class="innerBox mt-3">
          <report-suspect-stats
            title="Suspicious QR"
            :tooltipText="'Suspicious QR'"
            :tooltipBody="'Kode QR yang scan lebih dari 5 kali dan di tempat yang berbeda'"
            :value="reportSuspectData.stats.suspicious_qr"
            unit="Activities"
            :icon="`<svg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle cx='28.5' cy='28.5' r='28.5' fill='#FFE0F4'/>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M22 17H25.5C26.329 17 27 17.671 27 18.5V25.5C27 26.329 26.329 27 25.5 27H18.5C17.671 27 17 26.329 17 25.5V22C17 19.243 19.243 17 22 17ZM20 22V24H24V20H22C20.897 20 20 20.897 20 22ZM39 25.5C39 26.329 38.329 27 37.5 27H30.5C29.671 27 29 26.329 29 25.5V18.5C29 17.671 29.671 17 30.5 17H34C36.757 17 39 19.243 39 22V25.5ZM34 20H32V24H36V22C36 20.897 35.103 20 34 20ZM17 30.5C17 29.671 17.671 29 18.5 29H25.5C26.329 29 27 29.671 27 30.5V37.5C27 38.329 26.329 39 25.5 39H22C19.243 39 17 36.757 17 34V30.5ZM22 36H24V32H20V34C20 35.103 20.897 36 22 36Z' fill='#E92FA7'/>
                <path d='M33.3431 29C32.7009 28.9996 32.0698 29.1684 31.5135 29.4893C30.9572 29.8103 30.4952 30.2721 30.1741 30.8283C30.0908 30.9669 30.0359 31.1207 30.0126 31.2807C29.9894 31.4407 29.9983 31.6038 30.0387 31.7604C30.0791 31.9169 30.1503 32.0639 30.2482 32.1926C30.346 32.3214 30.4685 32.4294 30.6085 32.5103C30.7485 32.5912 30.9032 32.6434 31.0636 32.6639C31.224 32.6844 31.3868 32.6728 31.5427 32.6296C31.6985 32.5865 31.8442 32.5128 31.9713 32.4128C32.0983 32.3128 32.2042 32.1884 32.2827 32.0471C32.3894 31.8612 32.5431 31.7066 32.7285 31.5989C32.9138 31.4913 33.1243 31.4343 33.3386 31.4338C33.553 31.4333 33.7637 31.4892 33.9496 31.596C34.1354 31.7027 34.2899 31.8565 34.3975 32.0419C34.5051 32.2273 34.5619 32.4378 34.5624 32.6521C34.5628 32.8665 34.5068 33.0772 34.4 33.263C34.2931 33.4488 34.1393 33.6033 33.9538 33.7108C33.7684 33.8183 33.5579 33.8751 33.3436 33.8754C33.0203 33.8754 32.7102 34.0038 32.4816 34.2324C32.253 34.461 32.1246 34.7711 32.1246 35.0943C32.1246 35.4176 32.253 35.7277 32.4816 35.9563C32.7102 36.1849 33.0203 36.3133 33.3436 36.3133C34.3134 36.3132 35.2434 35.9279 35.9291 35.2421C36.6149 34.5564 37.0001 33.6262 37 32.6564C36.9999 31.6866 36.6146 30.7566 35.9288 30.0709C35.2431 29.3851 34.313 28.9999 33.3431 29ZM33.8062 37.63C33.5856 37.5276 33.3393 37.4937 33.0992 37.5325L32.8796 37.6055L32.6601 37.7152L32.4773 37.8736C32.285 38.0569 32.157 38.2975 32.1124 38.5594C32.0678 38.8214 32.1089 39.0908 32.2297 39.3275C32.3505 39.5641 32.5445 39.7555 32.7828 39.8731C33.0211 39.9907 33.291 40.0282 33.5523 39.98C33.8136 39.9319 34.0524 39.8006 34.2332 39.6058C34.4139 39.411 34.527 39.1631 34.5554 38.8989C34.5839 38.6347 34.5264 38.3683 34.3913 38.1395C34.2562 37.9106 34.0509 37.7315 33.8058 37.6287L33.8062 37.63Z' fill='#E92FA7'/>
                </svg>
            `"
            circle_bg_color="#ffe8e8"
            circle_text_color="#d05555"
          ></report-suspect-stats>
        </div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- Table Start -->
    <div class="innerBox mt-4 table-card">
      <div class="row column-title-row align-items-center">
        <div class="title mb-0 text-secondary fw-bold mr-3 ml-2">Report Suspect</div>

        <div class="d-flex ml-auto">
          <MultiSelect
            v-model="filter.part_number"
            :options="partNumberOptions"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            placeholder="Part Number"
            class="ml-2 report-suspect-multiselect"
            style="width: 200px"
          />

          <MultiSelect
            v-model="filter.reason"
            :options="[
              'Scan Different Location',
              'Scan More Than 5',
              'QR Not Found',
              'Suspicious QR',
            ]"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            placeholder="Reason"
            class="ml-2 mr-2 report-suspect-multiselect"
            style="width: 200px"
          />
        </div>
      </div>
      <div class="mt-3">
        <div class="bg-white box-content scan-history-table-wrapper">
          <div v-if="tableLoading" class="text-center mt-3 mb-3">
            <h4>Loading...</h4>
          </div>

          <div v-else style="overflow-x: auto; overflow-y: hidden">
            <table class="table scan-history-table" style="margin: 0">
              <thead>
                <tr>
                  <th
                    v-for="field in vue_suspect_table.fields"
                    :key="field.variable"
                    class="sortable"
                    @click="toggleSort(field.variable)"
                    style="user-select: none"
                  >
                    <span>{{ field.title }}</span>
                    <i
                      v-if="sortBy === field.variable"
                      class="ml-1 sort-icon fas"
                      :class="
                        sortOrder === 'DESC' || sortOrder === 'desc'
                          ? 'fa-sort-amount-down'
                          : 'fa-sort-amount-up'
                      "
                    ></i>
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in tableData"
                  :key="`${row.qrcode || row.part_number || index}-${index}`"
                >
                  <td>{{ row.qrcode || "-" }}</td>
                  <td>{{ row.part_number || "-" }}</td>
                  <td>{{ row.reason || "-" }}</td>
                  <td>{{ formatNumber(row.total_scan) || "-" }}</td>
                  <td>{{ formatDate(row.scan_date) || "-" }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn"
                      :style="
                        vue_suspect_table.buttons[0] && vue_suspect_table.buttons[0].style
                          ? vue_suspect_table.buttons[0].style
                          : 'color: #267CE5; background-color: transparent; border: none; text-decoration: underline; text-decoration-color: #267CE5'
                      "
                      @click="seeDetail(row)"
                    >
                      {{
                        (vue_suspect_table.buttons[0] && vue_suspect_table.buttons[0].title) ||
                        "Detail"
                      }}
                    </button>
                  </td>
                </tr>
                <tr v-if="!tableLoading && tableData.length === 0">
                  <td :colspan="vue_suspect_table.fields.length + 1" class="text-center">
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="row mt-3 pb-2 pagination-divider"
            v-if="!tableLoading && (tableData.length > 0 || total > 0 || maxPage > 1)"
          >
            <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-2">
                <span class="view-per-page-text mr-2 ml-2">View</span>
                <select
                  v-model.number="limitPerPage"
                  @change="onLimitChange"
                  class="form-control form-control-sm"
                  style="width: auto; display: inline-block; padding: 4px 8px"
                >
                  <option v-for="option in limitPerPageOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
                <span class="view-per-page-text ml-2">items per page</span>
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <p class="mt-2 mb-2 view-per-page-text mr-3">Showing Page {{ currentPage }}</p>
                <nav class="pagination-minimal mr-2">
                  <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage <= 1 || tableLoading }"
                      @click.stop.prevent="changePage('prev')"
                    >
                      <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled:
                          tableLoading || (!hasMoreData && currentPage >= maxPage && maxPage !== 0),
                      }"
                      @click.stop.prevent="changePage('next')"
                    >
                      <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <suspect-scan-map
      v-if="modal.map"
      :filter="modal.mapData"
      @closeModal="modal.map = false"
    ></suspect-scan-map>
    <!-- Modal End -->
  </div>
</template>

<script>
import moment from "moment";
import qs from "qs";


import suspectScanMap from "./children/suspectScanMap";
import reportSuspectStats from "./children/ReportSuspectStats.vue";



export default {
  metaInfo: {
    title: "Reports - Suspect",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    // console.log("for options part number:", this.$store.getters.getVariant);

    return {
      reportSuspectData: {
        stats: {
          total_report: null,
          scan_more_than_5: null,
          scan_different_location: null,
          fake_qr: null,
          suspicious_qr: null,
        },
      },
      modal: {
        map: false,
        mapData: null,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr flatpickr-inter-input",
      },
      options: {
        part_number: this.$store.getters.getVariant,
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
      },
      filter: {
        start: startDate,
        end: currentDate,
        part_number: null,
        reason: null,
        distance: null,
        search: null,
        // part_number: [],
      },
      partNumberOptions: [],
      vue_suspect_table: {
        fields: [
          // {title:'URL', variable:'url', is_image: true},
          { title: "QR Code", variable: "qrcode" },
          { title: "Part Number", variable: "part_number" },
          // {title:'Volume', variable:'volume'},
          { title: "Reason", variable: "reason" },
          {
            title: "Total Scan",
            variable: "total_scan",
            number_formatting: true,
          },
          { title: "Scan Date", variable: "scan_date" },
        ],
        update: 0,
        buttons: [
          {
            title: "Detail",
            style:
              "color: #267CE5; background-color: transparent; border: none; text-decoration: underline; text-decoration-color: #267CE5",
          },
        ],
        process_data: `
                        for (var i in data) data[i].volume = (parseInt(data[i].volume))/1000 + ' Lt'

                        for (var i in data) {
                            data[i].qrcode = data[i].qrcode ? data[i].qrcode : '-'
                            data[i].part_number = data[i].part_number ? data[i].part_number : '-'
                            data[i].reason = data[i].reason ? data[i].reason : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'

                        }
                      `,
      },
      // if (data[i].reason === "QR Not Found") {
      //   data[i].reason = "Fake QR";
      // }
      // console.log("Processed Data:", data); // Log the processed data
      tooltip: this.$store.state.tooltip.reports,
      // Table data properties
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      limitPerPageOptions: [10, 25, 50, 100],
      sortBy: "scan_date",
      sortOrder: "DESC",
      fetchDataTimer: null,
      latestUpdateDate: "2024-10-31",
    };
  },
  computed: {
    hasMoreData() {
      return this.tableData.length === this.limitPerPage;
    },
  },
  mounted() {
    // console.log("data table:", this.vue_suspect_table.process_data);
    // console.log("options part number:", this.options.part_number);
    // console.log("part_number (mounted):", this.filter.part_number);
    // console.log("part_number (mounted):", this.partNumberOptions);

    this.fetchLatestUpdate();
    this.loadStatsData();
    this.fetchPartNumbers();
    this.fetchTableData(true);
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  components: {


    suspectScanMap,
    reportSuspectStats,
    // reportSuspectStatsSuspicious,
    // VueSuspectTable
  },
  watch: {
    // "selected.date"() {
    //   let split = this.selected.date.split(" to ");
    //   this.filter.start = split[0];
    //   this.filter.end = split.length > 1 ? split[1] : split[0];
    // },
    // "selected.date": {
    // handler: debounce(function (newDate) {
    //   let split = newDate.split(" to ");
    //   this.filter.start = split[0];
    //   this.filter.end = split.length > 1 ? split[1] : split[0];

    //   this.loadStatsData();
    //   this.fetchPartNumbers();

    //   // Update the table
    //   this.vue_suspect_table.update++;
    //   this.scheduleFetch(true);
    // }, 300),
    // },
    // "$store.getters.getVariant": function (newVal, oldVal) {
    //   console.log("options old:", oldVal);
    //   console.log("options new:", newVal);
    // },
    "filter.part_number": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.vue_suspect_table.update++;
        this.scheduleFetch(true);
      }
    },
    "filter.reason": function (newVal, oldVal) {
      // console.log("filter reason new:", newVal);
      // console.log("filter reason old:", oldVal);

      if (newVal !== oldVal) {
        // if (newVal === "QR Not Found") {
        //   this.filter.reason = "Fake";
        //   this.vue_suspect_table.update++;
        //   // this.filter.reason = "QR Not Found";
        // } else {
        this.vue_suspect_table.update++;
        this.scheduleFetch(true);
      }

      // if (newVal !== oldVal) {
        //   const options = this.$refs.multiSelect.options;
      //   if (options.includes("QR Not Found") && newVal === "QR Not Found") {
      //     this.filter.reason = "Fake";
      //   } else {
      //     this.vue_suspect_table.update++;
      //   }
      // }
    },
    "vue_suspect_table.update": function () {
      if (!this.tableLoading) {
        this.scheduleFetch(true);
      }
    },
  },
  created() {
    // console.log("part_number (created):", this.$store.getters.getVariant);
  },
  methods: {
    async fetchLatestUpdate() {
      try {
        const resp = await this.$http.get("/suspect-report/latest-update");
        // Check for data.data.latest_update or data.latest_update or fallback to direct data
        const latestDate =
          (resp && resp.data && resp.data.data && resp.data.data.latest_update) ||
          (resp && resp.data && resp.data.latest_update) ||
          (resp && resp.data && resp.data.data) ||
          null;

        if (latestDate) {
          this.latestUpdateDate = moment(latestDate).format("YYYY-MM-DD");
        }
      } catch (error) {
        console.error("Failed to fetch latest update:", error);
      }
    },
    seeDetail(row) {
      // console.log("row from see detail:", row);

      let data = typeof row === "string" ? JSON.parse(row) : row;
      // console.log("data from see detail:", data);

      // if (data.reason === "QR Not Found") {
      //   this.modal.mapData = {
      //     qrcode: data.qrcode,
      //     start: this.filter.start,
      //     end: this.filter.end,
      //     reason: "Fake",
      //     distance: this.filter.distance,
      //   };
      // } else if (
      //   data.reason === "Scan beda tempat dan scan lebih dari 5 kali"
      // ) {
      //   this.modal.mapData = {
      //     qrcode: data.qrcode,
      //     start: this.filter.start,
      //     end: this.filter.end,
      //     reason: "Suspicious",
      //     distance: this.filter.distance,
      //   };
      // } else {
      // }

      this.modal.mapData = {
        qrcode: data.qrcode,
        start: this.filter.start,
        end: this.filter.end,
        reason: data.reason,
        distance: this.filter.distance,
      };

      this.modal.map = true;
    },
    scheduleFetch(immediate = false) {
      this.currentPage = 1;
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }
      if (immediate) {
        this.fetchTableData(true);
        return;
      }
      this.fetchDataTimer = setTimeout(() => {
        this.fetchTableData(true);
      }, 300);
    },
    async fetchTableData(resetPage = false) {
      if (resetPage) {
            this.currentPage = 1;
          }

          const params = {
            limit: this.limitPerPage,
            page: this.currentPage,
            order: this.sortOrder.toLowerCase(),
            by: this.sortBy,
          };

      if (this.filter.start) {
        params.start = this.filter.start;
      }

      if (this.filter.end) {
        params.end = this.filter.end;
      }

      if (this.filter.part_number) {
        params.part_number = this.filter.part_number;
      }

      if (this.filter.reason) {
        params.reason = this.filter.reason;
      }

      if (this.filter.distance) {
        params.distance = this.filter.distance;
      }

      const queryString = qs.stringify(params, {
        skipNulls: true,
        encodeValuesOnly: true,
      });

      this.tableLoading = true;

      try {
        const resp = await this.$http.get(`/suspect-report/?${queryString}`);
        const data =
          (resp && resp.data && resp.data.data) || (resp && resp.data && resp.data.rows) || [];
        const meta =
          (resp && resp.data && resp.data.meta) ||
          (resp && resp.data && resp.data.pagination) ||
          resp.data ||
          {};

        // Process data if process_data exists
        if (this.vue_suspect_table.process_data) {
          eval(this.vue_suspect_table.process_data);
        }

        this.tableData = Array.isArray(data) ? data : [];
        this.currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage;
        this.maxPage =
          meta.lastPage ||
          meta.last_page ||
          meta.totalPages ||
          meta.total_pages ||
          (this.tableData.length === this.limitPerPage ? this.currentPage + 1 : this.currentPage);
        this.total = meta.total || meta.totalItems || meta.total_count || 0;
      } catch (error) {
        console.error("Failed to fetch suspect report:", error);
        this.tableData = [];
        this.currentPage = 1;
        this.maxPage = 1;
        this.total = 0;
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    changePage(direction) {
      if (this.tableLoading) return;

      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
        this.fetchTableData();
        return;
      }

      const hasNextPage = this.hasMoreData || (this.maxPage && this.currentPage < this.maxPage);

      if (direction === "next" && hasNextPage) {
        this.currentPage += 1;
        this.fetchTableData();
      }
    },
    toggleSort(column) {
      if (column === this.sortBy) {
        this.sortOrder = this.sortOrder === "DESC" || this.sortOrder === "desc" ? "ASC" : "DESC";
      } else {
        this.sortBy = column;
        this.sortOrder = "DESC";
      }
      this.fetchTableData(true);
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }
      const parsed = moment(value);
      if (!parsed.isValid()) {
        return value;
      }
      return parsed.format("YYYY-MM-DD");
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return Number.parseInt(value, 10)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeFilter(filter) {
      for (const i in filter) this.filter[i] = filter[i];
      // console.log(this.filter);
    },
    async loadStatsData() {
      let url = [
        {
          url: "/suspect-report/total",
          variable: "total_report",
        },
        {
          url: "/suspect-report/total?reason=Scan Different Location",
          variable: "scan_different_location",
        },
        {
          url: "/suspect-report/total?reason=Scan More Than 5",
          variable: "scan_more_than_5",
        },
        {
          url: "/suspect-report/total?reason=QR Not Found",
          variable: "fake_qr",
        },
        {
          url: "/suspect-report/total?reason=Suspicious QR",
          variable: "suspicious_qr",
        },
      ];

      try {
        for (var i = 0; i < url.length; i++) {
          this.reportSuspectData.stats[url[i].variable] = null;

          let baseUrl = url[i].url;
          let separator = baseUrl.includes("?") ? "&" : "?";

          let resp = await this.$http.get(
            `${baseUrl}${separator}start=${encodeURIComponent(
              this.filter.start
            )}&end=${encodeURIComponent(this.filter.end)}`
          );

          this.reportSuspectData.stats[url[i].variable] = parseInt(resp.data.data.total);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchPartNumbers() {
      try {
    const params = {
      start: this.filter.start,
      end: this.filter.end,
      limit: 100,
      page: 1,
    };

    if (this.filter.part_number) params.part_number = this.filter.part_number;
    if (this.filter.reason) params.reason = this.filter.reason;
    if (this.filter.distance) params.distance = this.filter.distance;

    const query = qs.stringify(params, {
      skipNulls: true,
      encodeValuesOnly: true,
    });

    const resp = await this.$http.get(`/suspect-report/?${query}`);
    const products = resp.data.data || [];

    this.partNumberOptions = [
      ...new Set(
        products
          .map(p => p.part_number)
          .filter(Boolean)
          .map(p => p.replace(" (Inactive)", ""))
      ),
    ];
  } catch (error) {
    console.error("Error fetching part numbers:", error);
  }
    },
    async fetchAllProducts(baseUrl, lastPage) {
      // let currentPage = 1;
      let allProducts = [];

      for (let i = 1; i <= lastPage; i++) {
        const resp = await this.$http.get(`${baseUrl}&page=${i}`);
        const data = await resp.data.data;
        allProducts = allProducts.concat(data);
        // console.log(`fetch page ${i}:`, data);
      }

      // console.log("all products array:", allProducts);
      return allProducts;
    },
  },
};
</script>

<style scoped>
.report-suspect-page {
  font-family: "Inter", sans-serif !important;
}

.report-suspect-page * {
  font-family: "Inter", sans-serif !important;
}

.report-suspect-title {
  font-size: 16px;
  line-height: 24px;
  color: #4b4b4b;
  font-weight: 600;
  font-family: "Inter", sans-serif !important;
}

.latest-update-container {
  font-family: "Inter", sans-serif !important;
}

.latest-update-text {
  font-size: 14px;
  font-weight: 500;
  color: #4b4b4b;
}

.tooltip-icon {
  width: 18px;
  height: 18px;
  display: inline-block;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}

#view-stats .innerBox {
  padding: 0;
}

#view-stats,
#view-stats .innerBox {
  height: 100%;
}

.column-title-row {
  padding: 20px;
  margin-bottom: 0;
  border-bottom: 1px solid #dee2e6;
}

.title {
  font-size: 13px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 0;
}

.box-content {
  border-radius: 10px;
}

.scan-history-table-wrapper.box-content {
  padding: 0;
}

.table-card {
  padding: 0;
}

.prefix-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  font-family: "Font Awesome 5 Free", "Font Awesome 5 Pro", "Font Awesome 5 Brands", sans-serif !important;
  font-weight: 900;
  color: #4b4b4b;
}

.prefix-input .elegant-flatpickr {
  padding-left: 35px;
}

.flatpickr-inter .elegant-flatpickr,
.flatpickr-inter-input {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  color: #4b4b4b !important;
}

.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
  font-family: "Inter", sans-serif !important;
  table-layout: fixed;
  width: 100%;
}

.scan-history-table-wrapper .scan-history-table th,
.scan-history-table-wrapper .scan-history-table td {
  width: 20%;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
  font-weight: 700;
  font-size: 12px;
  font-family: "Inter", sans-serif !important;
  padding-top: 20px;
  padding-bottom: 20px;
}

.scan-history-table-wrapper .scan-history-table thead th .sort-icon {
  font-family: "Font Awesome 5 Free", "Font Awesome 5 Pro", "Font Awesome 5 Brands", sans-serif !important;
  font-weight: 900;
  font-style: normal;
  display: inline-block;
  margin-left: 4px;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  padding-left: 20px;
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
  font-weight: 400;
  font-size: 12px;
  font-family: "Inter", sans-serif !important;
  padding-top: 15px;
  padding-bottom: 15px;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  padding-left: 20px;
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.pagination-divider {
  border-top: 1px solid #e6e6e6;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 16px;
  overflow: hidden;
}

.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled) .page-link:hover {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}

.view-per-page-text {
  font-family: "Inter", sans-serif !important;
  color: #cbcbcb;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  margin: 0;
}

.view-per-page-text.mr-2 {
  margin-right: 8px;
}

.view-per-page-text.ml-2 {
  margin-left: 8px;
}

.view-per-page-text.mr-3 {
  margin-right: 20px;
}

.report-suspect-page :deep(.multiselect) {
  position: relative;
  display: inline-block;
  width: 100%;
}

.report-suspect-page :deep(.multiselect__single),
.report-suspect-page :deep(.multiselect__placeholder),
.report-suspect-page :deep(.multiselect__input),
.report-suspect-page :deep(.multiselect__tags) {
  color: #2f2f2f;
  font-size: 12px;
  font-family: "Inter", sans-serif !important;
}

.report-suspect-page :deep(.multiselect__input),
.report-suspect-page :deep(.multiselect__single) {
  min-height: auto;
  line-height: 1.4;
}

.report-suspect-page :deep(.stats-card-row) {
  display: flex;
  align-items: center;
}

.report-suspect-page :deep(.stats-card-row > [class*="col-"]) {
  display: flex;
  align-items: center;
}

.report-suspect-page :deep(.highlight--stats) {
  width: 100%;
}

.report-suspect-page :deep(.stats--icon) {
  justify-content: center;
}

.report-suspect-page :deep(.multiselect__select) {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 100%;
  padding: 0;
  margin: 0;
  text-align: center;
  border-left: none;
  z-index: 1;
}

.report-suspect-page :deep(.multiselect__select:before) {
  display: none !important;
}

.report-suspect-page :deep(.multiselect__select:after) {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 4px;
  background-image: url("~@/assets/img/multiselect-chevron.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.report-suspect-page :deep(.multiselect--active .multiselect__select:after) {
  transform: translateY(-50%) rotate(180deg);
}

.report-suspect-page :deep(.multiselect__tags) {
  padding-right: 40px;
}
</style>
